// don't shorten import because ../../lib import and exports everything
import { configureApplication } from "../../lib/configuration";

configureApplication({
  BASE_URL: "/app/commons",
});
